


    <div *ngIf="entity">
      <firmware-approval-widget [entity]="entity" [layout]="'full'" [options]="{}" ></firmware-approval-widget>
    </div>
  